<template>
  <div class="info_box">
    <div class="owner_title">录入金主信息</div>
    <div class="owner_box">
      <el-form
        ref="ownerInfoForm"
        :model="ownerInfoForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="金主昵称" prop="name">
          <el-input class="inpt_size" v-model="ownerInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="金主QQ" prop="qq_account">
          <el-input
            class="inpt_size"
            v-model="ownerInfoForm.qq_account"
          ></el-input>
        </el-form-item>
        <el-form-item label="金主微信" prop="wx_account">
          <el-input
            class="inpt_size"
            v-model="ownerInfoForm.wx_account"
          ></el-input>
        </el-form-item>
        <el-form-item label="金主电话号码" prop="mobile">
          <el-input
            class="inpt_size"
            v-model="ownerInfoForm.mobile"
            οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)"
          ></el-input>
        </el-form-item>
        <el-form-item label="添加标签" prop="connectionlabel_ids">
          <el-checkbox
            v-for="(item, index) in ownerInfoForm.connectionlabel_ids"
            :key="index"
            :label="item.name"
            @change="checkedLabel(item)"
            >{{ item.name }}</el-checkbox
          >
        </el-form-item>
        <el-form-item label="添加批注" prop="connectionremark">
          <el-input
            class="add_ramark"
            v-model="ownerInfoForm.connectionremark"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="info_btn"
            type="primary"
            round
            @click="onSubmitOwnerInfo"
            >确认录入</el-button
          >
          <el-button class="info_btn" type="info" plain round @click="goBack"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { add_connection, label_list } from "@/utils/owner";
export default {
  data() {
    return {
      ownerLabelChecked: [], //选中的标签
      ownerInfoForm: {
        departmentuser_id: "", //所属金主部id
        name: "", //金主昵称
        qq_account: "", //金主QQ
        wx_account: "", //金主微信
        mobile: "", //金主电话号码
        connectionlabel_ids: "", //标签
        connectionremark: "" //批注
      },
      rules: {
        name: { required: true, trigger: "blur", message: "金主昵称不能为空" },
        qq_account: [
          { required: true, trigger: "blur", message: "金主QQ不能为空" },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "QQ格式不正确" }
        ],
        connectionlabel_ids: {
          required: true,
          trigger: "blur",
          message: "标签不能为空"
        }
      },

      fileList: []
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.init();
  },
  methods: {
    init() {
      this.getOwnerLabel();
    },
    // 获取金主标签
    getOwnerLabel() {
      var that = this;
      label_list().then(res => {
        if (res.data.code == 1) {
          that.ownerInfoForm.connectionlabel_ids = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    //录入金主信息确认提交
    onSubmitOwnerInfo() {
      var that = this;
      that.$refs["ownerInfoForm"].validate(valid => {
        console.log(valid);
        if (valid) {
          var str = "";
          var len = that.ownerLabelChecked.length;
          that.ownerLabelChecked.forEach(function(item, index) {
            if (index < len - 1) {
              str += item + ",";
            } else {
              str += item;
            }
          });
          that.ownerInfoForm.connectionlabel_ids = str;
          that.ownerInfoForm.departmentuser_id = that.ownerId;
          let obj = {
            ...that.ownerInfoForm
          };
          add_connection(obj).then(res => {
            if (res.data.code == 1) {
              that.$message.success(res.data.msg);
              that.$router.push("/myOwner");
            } else {
              that.$message.error(res.data.msg);
              this.$refs.ownerInfoForm.resetFields();
              this.getOwnerLabel();
            }
          });
        } else {
          // 校验失败
          that.$message.error("新增失败，请输入正确的内容");
          return false;
        }
      });
    },

    checkedLabel(val) {
      var that = this;
      if (that.ownerLabelChecked.includes(val.id)) {
        that.ownerLabelChecked = that.ownerLabelChecked.filter(
          item => item != val.id
        );
      } else {
        that.ownerLabelChecked.push(val.id);
      }
    },
    //   取消返回首页
    goBack() {
      var that = this;
      that.$router.push("/myOwner");
    },
    // 文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.info_box {
  background-color: #ffffff;
  height: 100%;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.owner_box {
  padding: 45px 30px;
}
.el-main {
  padding: 0;
}
.inpt_size {
  width: 200px;
}
.add_ramark {
  width: 475px;
}
.upload_size {
  width: 230px;
}
.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}
.info_btn {
  width: 200px;
  height: 35px;
}
.el-input__inner {
  background-color: RGB(250, 250, 250);
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerInfo.vue